/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Invoke_Api_UseInputs */



/**
* | output |
* | --- |
* | "Use invoke_api tools" |
*
* @param {Rights_Cap_Invoke_Api_UseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_invoke_api_use = /** @type {((inputs?: Rights_Cap_Invoke_Api_UseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Invoke_Api_UseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("invoke_api-Tools nutzen")
	return /** @type {LocalizedString} */ ("Use invoke_api tools")
});